import { render, staticRenderFns } from "./igt-notifications.vue?vue&type=template&id=6c9e3f53&scoped=true&"
import script from "./igt-notifications.vue?vue&type=script&lang=js&"
export * from "./igt-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9e3f53",
  null
  
)

export default component.exports